"use strict";

var _slicedToArray = require("/var/www/attheme-editor.snejugal.ru/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Serializes the color.
 * @param color The color to serialize.
 * @param colorSignature The way the color should be encoded, "hex" for
 * #aarrggbb and "int" for Java int color.
 * @returns The serialized color.
 */

var serializeColor = function serializeColor(color, colorSignature) {
  var red = color.red.toString(16).padStart(2, "0");
  var green = color.green.toString(16).padStart(2, "0");
  var blue = color.blue.toString(16).padStart(2, "0");
  var alpha = color.alpha.toString(16).padStart(2, "0");
  var hex = "".concat(alpha).concat(red).concat(green).concat(blue);

  if (colorSignature === "hex") {
    return "#".concat(hex);
  }

  return String(Number.parseInt(hex, 16) << 0);
};
/**
 * Serializes the theme.
 * @param theme The theme to serialize.
 * @param colorSignature The way the colors should be encoded, "hex" for
 * #aarrggbb and "int" for Java int color.
 * @returns The serialized theme.
 */


var serializeTheme = function serializeTheme(theme) {
  var colorSignature = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "int";
  var result = "";
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = theme[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var _ref3 = _step.value;

      var _ref2 = _slicedToArray(_ref3, 2);

      var variable = _ref2[0];
      var color = _ref2[1];
      var hex = serializeColor(color, colorSignature);
      result += "".concat(variable, "=").concat(hex, "\n");
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator["return"] != null) {
        _iterator["return"]();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  if (theme.hasWallpaper()) {
    result += "\nWPS\n".concat(theme.getWallpaper(), "\nWPE\n");
  }

  return result;
};

exports["default"] = serializeTheme;